import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConfigurationService } from '@sondermind/configuration';
import { HttpService } from '@sondermind/http';
import { IAPIFetchResponse, IAPIFetchRequestOptions } from '@sondermind/utilities/models-http';
import { Address, IAddress } from '@sondermind/utilities/models-location';

type UpdatePvlType = {
  primary_virtual_location: IAddress;
};

@Injectable({
  providedIn: 'root'
})

export class PrimaryVirtualLocationHttpService {
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpService,
  ) {}

  index$(providerId: number, opts: Partial<IAPIFetchRequestOptions> = {}): Observable<IAPIFetchResponse<Address>> {
    const params = this.http.generateFetchParams(opts);
    const url = `${this.configurationService.env.svcBase}/provider_profiles/persona_providers/${providerId.toString()}/primary_virtual_location`;

    return this.http
      .get<IAPIFetchResponse<IAddress>>(url, params)
      .pipe(
        map((res) => ({ ...res, data: res.data ? new Address(res.data) : null })),
        this.http.handleHttpError()
      );
  }

  updatePrimaryVirtualAddress(providerId: number, primaryVirtualAddress: UpdatePvlType): Observable<Address> {
    const url = `${this.configurationService.env.svcBase}/provider_profiles/persona_providers/${providerId.toString()}/primary_virtual_location`;
    return this.http.post<IAPIFetchResponse<IAddress>>(url, primaryVirtualAddress)
      .pipe(
        map((res) => (res.data ? new Address(res.data) : null)),
        this.http.handleHttpError()
      );
  }
}
